import { Injectable, Injector, Type } from '@angular/core';
import { Namespace } from 'enums-lib';
import { BullhornAiAssistPromptService } from './bullhorn.ai-assist-prompt.service';
import { IAiAssistPromptService } from './iaiassistpromptservice';

@Injectable({ providedIn: 'root' })
export class AiAssistPromptFactory {
  private readonly datasource: Record<string, Type<IAiAssistPromptService>> = {
    [Namespace.bullhorn]: BullhornAiAssistPromptService,
  };

  constructor(private injector: Injector) {}

  getInstance(namespace: Namespace | string): IAiAssistPromptService {
    const provider = this.datasource[namespace];
    if (!provider) {
      console.warn(`No AI assist prompt service for '${namespace}'.`);
      return;
    }
    return this.injector.get(provider);
  }
}
